const images = {
    icon_notify: 'img/zalopay_notify.png',
};

export default images;